import React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
//import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useLocation, Link as RouterLink } from 'react-router-dom';

export const Breadcrumb: React.FC = () => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);

    return (
        <div
        style={{
            marginTop: '30px',
            marginBottom: '20px',
            marginLeft: '100px',
            padding: '10px 20px',
            borderRadius: '20px',
            background: 'linear-gradient(to right, #179661, #0AA6E3)',
            fontFamily: "'Arial', sans-serif",
            width: 'fit-content',
        }}
        >
        <Breadcrumbs
            separator={'>'}
            aria-label="breadcrumb"
        >
            <Link
            component={RouterLink}
            to="/"
            underline="hover"
            color="inherit"
            style={{ fontWeight: 'bold' }}
            >
            Home
            </Link>
            {pathnames.map((value, index) => {
            const to = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            return isLast ? (
                <Typography
                key={to}
                color="text.primary"
                style={{ textDecoration: 'underline', fontWeight: 'bold' }}
                >
                {value.charAt(0).toUpperCase() + value.slice(1)}
                </Typography>
            ) : (
                <Link
                key={to}
                component={RouterLink}
                to={to}
                underline="hover"
                color="inherit"
                style={{ fontWeight: 'bold' }}
                >
                {value.charAt(0).toUpperCase() + value.slice(1)}
                </Link>
            );
            })}
        </Breadcrumbs>
        </div>
    );
};
